/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Slot_Generation_ExistingInputs */

const en_job_form_slot_generation_existing = /** @type {(inputs: Job_Form_Slot_Generation_ExistingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Existing unbooked appointments`)
};

const de_job_form_slot_generation_existing = /** @type {(inputs: Job_Form_Slot_Generation_ExistingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestehende ungebuchte Termine`)
};

/**
* | output |
* | --- |
* | "Existing unbooked appointments" |
*
* @param {Job_Form_Slot_Generation_ExistingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_slot_generation_existing = /** @type {((inputs?: Job_Form_Slot_Generation_ExistingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Slot_Generation_ExistingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_slot_generation_existing(inputs)
	return en_job_form_slot_generation_existing(inputs)
});